import React from "react";
import ReportPermission from "./ReportPermission";

export default function ReportPermissionPage(props) {
  return <ReportPermission {...props} />;
}



// WEBPACK FOOTER //
// src/pages/ReportPermission/index.js